"use client";

import { c as _c } from "react/compiler-runtime";
import { useRef, useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Mousewheel, Keyboard, Navigation } from "swiper/modules";
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "./styles.css";
export const TikTokSliderBlock = t0 => {
  const $ = _c(56);
  const {
    embedCodes,
    layout: t1,
    slidesPerView: t2,
    showNavigation: t3,
    showPagination: t4
  } = t0;
  const layout = t1 === undefined ? "horizontal" : t1;
  const slidesPerView = t2 === undefined ? "4" : t2;
  const showNavigation = t3 === undefined ? true : t3;
  const showPagination = t4 === undefined ? true : t4;
  const swiperRef = useRef(null);
  const [loadTikTok, setLoadTikTok] = useState(false);
  const [isMounted, setIsMounted] = useState(false);
  const desktopSlidesPerView = parseInt(slidesPerView || "4", 10);
  const isVertical = layout === "vertical";
  let t5;
  let t6;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => {
      setIsMounted(true);
    };
    t6 = [];
    $[0] = t5;
    $[1] = t6;
  } else {
    t5 = $[0];
    t6 = $[1];
  }
  useEffect(t5, t6);
  let t7;
  let t8;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => {
      if (swiperRef.current) {
        swiperRef.current.on("slideChange", () => {
          setTimeout(() => {
            const mousewheel = swiperRef.current?.params.mousewheel;
            if (typeof mousewheel === "object") {
              mousewheel.releaseOnEdges = false;
            }
          }, 500);
        });
        swiperRef.current.on("reachEnd", () => {
          setTimeout(() => {
            const mousewheel_0 = swiperRef.current?.params.mousewheel;
            if (typeof mousewheel_0 === "object") {
              mousewheel_0.releaseOnEdges = true;
            }
          }, 750);
        });
      }
    };
    t8 = [];
    $[2] = t7;
    $[3] = t8;
  } else {
    t7 = $[2];
    t8 = $[3];
  }
  useEffect(t7, t8);
  let t10;
  let t9;
  if ($[4] !== isMounted) {
    t9 = () => {
      if (!isMounted) {
        return;
      }
      setLoadTikTok(true);
      return () => {
        setLoadTikTok(false);
      };
    };
    t10 = [isMounted];
    $[4] = isMounted;
    $[5] = t10;
    $[6] = t9;
  } else {
    t10 = $[5];
    t9 = $[6];
  }
  useEffect(t9, t10);
  let t11;
  if ($[7] !== isMounted || $[8] !== loadTikTok) {
    t11 = () => {
      if (!loadTikTok || !isMounted) {
        return;
      }
      const existingScript = document.querySelector("script[src=\"https://www.tiktok.com/embed.js\"]");
      if (existingScript) {
        existingScript.remove();
      }
      const script = document.createElement("script");
      script.src = "https://www.tiktok.com/embed.js";
      script.async = true;
      document.body.appendChild(script);
      script.onload = _temp;
      return () => {
        if (document.body.contains(script)) {
          document.body.removeChild(script);
        }
      };
    };
    $[7] = isMounted;
    $[8] = loadTikTok;
    $[9] = t11;
  } else {
    t11 = $[9];
  }
  let t12;
  if ($[10] !== embedCodes || $[11] !== isMounted || $[12] !== loadTikTok) {
    t12 = [loadTikTok, embedCodes, isMounted];
    $[10] = embedCodes;
    $[11] = isMounted;
    $[12] = loadTikTok;
    $[13] = t12;
  } else {
    t12 = $[13];
  }
  useEffect(t11, t12);
  let t13;
  let t14;
  if ($[14] !== isMounted) {
    t13 = () => {
      if (!isMounted) {
        return;
      }
      const handleSlideChange = _temp3;
      if (swiperRef.current) {
        swiperRef.current.on("slideChange", handleSlideChange);
      }
      return () => {
        if (swiperRef.current) {
          swiperRef.current.off("slideChange", handleSlideChange);
        }
      };
    };
    t14 = [isMounted];
    $[14] = isMounted;
    $[15] = t13;
    $[16] = t14;
  } else {
    t13 = $[15];
    t14 = $[16];
  }
  useEffect(t13, t14);
  const t15 = `bg-white tiktok-slider-section py-32 ${isVertical ? "vertical" : "horizontal"}`;
  const t16 = isVertical ? "vertical" : "horizontal";
  let t17;
  if ($[17] !== desktopSlidesPerView || $[18] !== isVertical) {
    t17 = !isVertical ? {
      640: {
        slidesPerView: 1
      },
      768: {
        slidesPerView: Math.min(2, desktopSlidesPerView)
      },
      1024: {
        slidesPerView: desktopSlidesPerView
      }
    } : undefined;
    $[17] = desktopSlidesPerView;
    $[18] = isVertical;
    $[19] = t17;
  } else {
    t17 = $[19];
  }
  const t18 = !isVertical && (showNavigation ?? false);
  let t19;
  if ($[20] !== isVertical || $[21] !== showPagination) {
    t19 = showPagination ?? false ? {
      clickable: true,
      dynamicBullets: !isVertical
    } : false;
    $[20] = isVertical;
    $[21] = showPagination;
    $[22] = t19;
  } else {
    t19 = $[22];
  }
  let t20;
  if ($[23] !== isVertical) {
    t20 = isVertical ? {
      forceToAxis: true,
      sensitivity: 1,
      releaseOnEdges: true,
      thresholdDelta: 50,
      thresholdTime: 200
    } : false;
    $[23] = isVertical;
    $[24] = t20;
  } else {
    t20 = $[24];
  }
  let t21;
  if ($[25] !== showPagination) {
    t21 = showPagination ? [Pagination] : [];
    $[25] = showPagination;
    $[26] = t21;
  } else {
    t21 = $[26];
  }
  let t22;
  if ($[27] !== isVertical || $[28] !== showNavigation) {
    t22 = !isVertical && showNavigation ? [Navigation] : [];
    $[27] = isVertical;
    $[28] = showNavigation;
    $[29] = t22;
  } else {
    t22 = $[29];
  }
  let t23;
  if ($[30] !== isVertical) {
    t23 = isVertical ? [Mousewheel] : [];
    $[30] = isVertical;
    $[31] = t23;
  } else {
    t23 = $[31];
  }
  let t24;
  if ($[32] !== t21 || $[33] !== t22 || $[34] !== t23) {
    t24 = [...t21, Keyboard, ...t22, ...t23];
    $[32] = t21;
    $[33] = t22;
    $[34] = t23;
    $[35] = t24;
  } else {
    t24 = $[35];
  }
  const t25 = `tiktok-swiper ${isVertical ? "vertical-swiper h-screen" : ""}`;
  let t26;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = swiper => {
      swiperRef.current = swiper;
    };
    $[36] = t26;
  } else {
    t26 = $[36];
  }
  let t27;
  if ($[37] !== isVertical) {
    t27 = isVertical ? {
      threshold: 5,
      touchRatio: 1,
      touchAngle: 45,
      edgeSwipeDetection: true,
      edgeSwipeThreshold: 20,
      touchReleaseOnEdges: true,
      touchEventsTarget: "container",
      touchMoveStopPropagation: true,
      touchStartPreventDefault: false,
      touchStartForcePreventDefault: true,
      cssMode: false,
      simulateTouch: true,
      allowTouchMove: true
    } : {};
    $[37] = isVertical;
    $[38] = t27;
  } else {
    t27 = $[38];
  }
  let t28;
  if ($[39] !== embedCodes || $[40] !== isMounted || $[41] !== isVertical) {
    t28 = embedCodes?.map((item, index) => <SwiperSlide key={index} className={`tiktok-slide ${isVertical ? "h-full" : ""}`}><div className={`tiktok-embed-container ${isVertical ? "h-full" : ""}`}>{isMounted && <div dangerouslySetInnerHTML={{
          __html: item.embedCode
        }} />}{!isMounted && <div className="tiktok-embed-placeholder"><div className="tiktok-loader" /></div>}</div></SwiperSlide>);
    $[39] = embedCodes;
    $[40] = isMounted;
    $[41] = isVertical;
    $[42] = t28;
  } else {
    t28 = $[42];
  }
  let t29;
  if ($[43] !== t16 || $[44] !== t17 || $[45] !== t18 || $[46] !== t19 || $[47] !== t20 || $[48] !== t24 || $[49] !== t25 || $[50] !== t27 || $[51] !== t28) {
    t29 = <div className="container mx-auto px-4"><Swiper direction={t16} dir="rtl" slidesPerView={1} spaceBetween={30} breakpoints={t17} speed={800} watchSlidesProgress={true} navigation={t18} pagination={t19} mousewheel={t20} modules={t24} className={t25} onSwiper={t26} {...t27}>{t28}</Swiper></div>;
    $[43] = t16;
    $[44] = t17;
    $[45] = t18;
    $[46] = t19;
    $[47] = t20;
    $[48] = t24;
    $[49] = t25;
    $[50] = t27;
    $[51] = t28;
    $[52] = t29;
  } else {
    t29 = $[52];
  }
  let t30;
  if ($[53] !== t15 || $[54] !== t29) {
    t30 = <section data-theme="light" className={t15}>{t29}</section>;
    $[53] = t15;
    $[54] = t29;
    $[55] = t30;
  } else {
    t30 = $[55];
  }
  return t30;
};
function _temp() {
  if (typeof window !== "undefined" && window.TIKTOK && typeof window.TIKTOK.reload === "function") {
    window.TIKTOK.reload();
  }
}
function _temp2() {
  if (typeof window !== "undefined" && window.TIKTOK && typeof window.TIKTOK.reload === "function") {
    window.TIKTOK.reload();
  }
}
function _temp3() {
  setTimeout(_temp2, 100);
}